import { Button } from "common/components/ui/Button";
import {
  DialogClose,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface RemoveClientProps {
  email: string;
  onBack: () => void;
}

export default function RemoveClient({ email, onBack }: RemoveClientProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { name: workspaceName } = useSelectedWorkspaceContext();

  function handleRemoveClick() {}

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>Remove from workspace?</Title>

      <Description className="mb-8">
        Are you sure you want to remove{" "}
        <span className="font-semibold text-black-950">
          &apos;{email}&apos;{" "}
        </span>
        from {workspaceName}
      </Description>

      <div className="flex justify-between gap-x-2.5">
        <Button
          variant="secondary-black"
          className="lg:flex-1"
          disabled={false}
          onClick={onBack}
        >
          Cancel
        </Button>

        <DialogClose asChild>
          <Button
            variant="outline-danger"
            className="lg:flex-1"
            isLoading={false}
            onClick={handleRemoveClick}
          >
            Remove
          </Button>
        </DialogClose>
      </div>
    </>
  );
}
